import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import { revoked as tokenRevoked } from "../features/auth/authSlice";

export const unauthenticatedMiddleware: Middleware =
    ({ dispatch }) =>
    (next) =>
    (action) => {
        if (isRejectedWithValue(action) && action.payload.status === 401) {
            if (window.location.pathname === '/login') {
                return next(action);
            }
            dispatch(tokenRevoked());
        }
        return next(action);
    };
